// extracted by mini-css-extract-plugin
export var contained = "FullWidthSummaryDisplay-module--contained--1ec56";
export var container = "FullWidthSummaryDisplay-module--container--826a7";
export var summaries = "FullWidthSummaryDisplay-module--summaries--952d9";